import { orderFormSpace } from 'feature/productOrder/namespaces/orderFormSpace'
import { ProductOrder } from 'feature/productOrder/ProductOrder'
import { MainLayout } from 'layouts'
import { RequireAuth } from 'router/RequireAuth'

export function CompanyServiceOrderPage() {
  return (
    <RequireAuth>
      <MainLayout>
        <ProductOrder
          orderType={orderFormSpace.FormType.service}
          forceUserType='company'
        />
      </MainLayout>
    </RequireAuth>
  )
}
